module.exports = __webpack_public_path__ + "img/stopwatch.8d73114c.svg";